import { DateTime } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'typedefs';
import styles from "./styles.module.scss";
import { useTranslation } from 'react-i18next';

const ReportListItemWithDates = ({
  createdAt,
  format,
  reportFileUrl,
  innerRef,
  filters,
}) => {
  const timeZone = useSelector((state: RootState) => state.user.data.timezone);
  const locale = useSelector((state: RootState) => state.user.data.locale);
  const date = DateTime.fromISO(createdAt).setZone(timeZone).setLocale(locale).toFormat('MMM d, yyyy • h:mm a');
  const { t } = useTranslation();

  let periodLabel: string;
  if (filters['snapshotDate']) {
    periodLabel = DateTime.fromISO(filters['snapshotDate']).setZone(timeZone).toFormat('MMM d, yyyy');
  } else {
    const from = DateTime.fromISO(filters['periodStartDate']).setZone(timeZone).toFormat('MMM d, yyyy');
    const to = DateTime.fromISO(filters['periodEndDate']).setZone(timeZone).toFormat('MMM d, yyyy');
    periodLabel = `${from} - ${to}`;
  }

  return (
    <div
      ref={innerRef}
      className={styles.container}
    >
      <span className={styles.date_width}>{t(date)}</span>
      <span className={styles.format_width}>{t(format.toUpperCase())}</span>
      <span className={styles.period_width}>{t(periodLabel)}</span>
      <a href={reportFileUrl} className={styles.download_width}>
        {t('Download')}
      </a>
    </div>
  );
};

export default ReportListItemWithDates;
